<template>
	<svg class="ls-icon ls-icon-id" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<!-- Icon from Material Design Icons by Pictogrammers - https://github.com/Templarian/MaterialDesign/blob/master/LICENSE -->
		<path fill="currentColor" d="M10 7v2H9v6h1v2H6v-2h1V9H6V7zm6 0a2 2 0 0 1 2 2v6c0 1.11-.89 2-2 2h-4V7m4 2h-2v6h2z" />
	</svg>
</template>
